var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88131 14.8036C3.4615 14.8036 3.10376 14.6557 2.80811 14.3601C2.51245 14.0644 2.36462 13.7067 2.36462 13.2869V4.04923C2.36462 3.62942 2.51245 3.27169 2.80811 2.97604C3.10376 2.68038 3.4615 2.53255 3.88131 2.53255H4.50014V1.19922H5.92514V2.53255H11.0751V1.19922H12.5001V2.53255H13.119C13.5388 2.53255 13.8965 2.68038 14.1922 2.97604C14.4878 3.27169 14.6357 3.62942 14.6357 4.04923V13.2869C14.6357 13.7067 14.4878 14.0644 14.1922 14.3601C13.8965 14.6557 13.5388 14.8036 13.119 14.8036H3.88131ZM3.88131 13.2869H13.119V6.66807H3.88131V13.2869ZM3.88131 5.33473H13.119V4.04923H3.88131V5.33473Z",
    fill: "#1D5AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.aec94dbc8d6471a66b7f48b49bb991ad.svg";
export { ForwardRef as ReactComponent };